<div class="customer-information">
  <app-section-header [title]="'Customer Information'" />
  <form class="content" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-row" *ngFor="let formField of formFields; let i = index;"
      [ngClass]="{'col-8': (i == 4 || i == 6), 'col-4': true}">
      <form-field [formField]="formField" [form]="form"> </form-field><span> <i class="pi pi-info-circle" *ngIf="i==3">
        </i></span>
    </div>
  </form>
</div>